import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import { TextLabelPlacementEnum } from 'components/elements/custom-form-control';
import Text from 'components/elements/text';
import { CardSection } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import FlightRescheduleAddOnsTable from './add-ons-table';
import FlightRescheduleGuestTable from './guest-table';
import { ScheduleCardHeader, ScheduleCardHeaderLeft } from '../../style';

interface Props {
  parentIndex: number;
}

export default function FlightRescheduleItemCard(props: Props) {
  const { t } = useTranslation();
  return (
    <CardSection>
      <ScheduleCardHeader>
        <ScheduleCardHeaderLeft>
          <Text variant="HeadingXSmall">
            {t('ticketSales:schedule_extra', {
              extra: props.parentIndex + 1,
            })}
          </Text>
          <Input
            type="text"
            name={`flightSales.${props.parentIndex}.bookingCode`}
            label={t('common:booking_code')}
            labelPlacement={TextLabelPlacementEnum.Left}
            placeholder={t('common:booking_code')}
            noMargin
            disabled
          />
        </ScheduleCardHeaderLeft>
      </ScheduleCardHeader>
      <Separator gap={16} />
      <FlightRescheduleGuestTable parentIndex={props.parentIndex} />
      <Separator gap={8} />

      <FlightRescheduleAddOnsTable parentIndex={props.parentIndex} />
    </CardSection>
  );
}
